import { useContext } from 'react';
import { AddProjectContext } from '../../../../../TemporaryConmonents/AddProject/Context/AddProjectContext';

export const useProjectTeamManagersRow = () => {
    const { managers } = useContext(AddProjectContext);

    return { managers };
};
